<template>
  <div  v-if="currentRelance">
    <div class="is-marginless is-paddingless section section-details">
      <div class="entete border-entete">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <a ref="lienDownload"></a>
                <h1 class="title is-size-3">
                  {{ $t('relance.titleDetailRelance') + getFacturesCodes }}
                  <b-tag v-if="!currentRelance.actif"
                    type="has-background-subMenu"
                    class="has-text-white mgl-5px">
                    {{$t('relance.etatRelance')}}
                  </b-tag>
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"></app-breadcrumb>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <router-link  :to="routeRetour"
                           class="button"
                           :class="{'text-access-no-permission':
                                   !checkPermissions(permissionsRelances.lecture)}">
                {{ $t('general.button.return') }}
              </router-link>
                <dropdownButton
                  type="is-addOrEdit"
                  class="mgr-2"
                  :permission="permissionsRelances.maj"
                  :actions="actionSecondary"
                  @click="callFct('editRelance', currentRelance.id)">
                    {{ $t('detail.buttons.edit') }}
                </dropdownButton>

              <button class="button"
                      @click="$refs.dropdownEdition.toggle()">
                <div>
                  <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                  <b-dropdown ref="dropdownEdition">
                    <div slot="trigger">
                      <b-icon icon="chevron-down"
                              class="has-text-secondary-icon">
                      </b-icon>
                    </div>
                    <b-dropdown-item
                      @click="checkPermAndCallFct('editer', 'edition', 'Pdf')"
                      :class="classTextDroit('lecture')">
                      {{ $t('general.popUpEdition.type.pdf') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="checkPermAndCallFct('editer', 'edition', 'Docx')"
                      :class="classTextDroit('lecture')">
                      {{ $t('general.popUpEdition.type.docx') }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </button>
              <button
                class="button"
                :class="{
                  'text-access-no-permission': !checkPermissions(permissionsRelances.lecture)
                }"
                @click="checkPermAndCallFct('lecture', 'openPopUpEmail')">
                <b-icon
                  icon="email-plus"
                  type="is-default"
                  :class="classTextDroit('lecture')">
                </b-icon>
              </button>
              <button class="button"
                      @click="checkPermAndCallFct('maj', 'showAddAttachmentModal')">
                <b-icon icon="paperclip" type="is-default" :class="classTextDroit('maj')"></b-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="columns" v-if="currentRelance">
      <div class="column is-9">
        <div class="card">
          <div class="card-content ql-snow">
            <p class="is-size-6 has-text-justified" disabled
               v-html="currentRelance.texte"></p>
          </div>
        </div>
        <br>
        <div class="card">
          <header class="header-card">
            <p>{{ $t('relance.commentaire')}}</p>
          </header>
          <div class="card-content has-text-default is-size-7">
            <b-field :label="$t('relance.commentaire') + ' :'"
                 custom-class="has-text-default is-italic has-text-weight-light mgb-0">
              <span class="has-text-link has-text-weight-bold">
                {{ currentRelance.commentaire }}
              </span>
            </b-field>
          </div>

        </div>
        <br>
        <div class="card">
          <header class="header-card">
            <p>{{ $t('piecesJointes.attachments')}}</p>
          </header>
          <div class="card-content">
            <app-pieces-jointes
              readOnly
              deletable
              autoSave
              :checkPermissions="checkPermissions(permissionsRelances.maj)"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <step-relance-enregistrement
          :allRelances="allRelance"
          :idCurrentRelance="currentRelance.id"
          @changeCurrentRelance="changeCurrentRelance"
          :isDetail="true">
        </step-relance-enregistrement>
      </div>
    </div>
    <b-modal v-model="popUpMail" has-modal-card class="modal" width="1014px">
      <pop-up-mail
        :mail="mail"
        :contacts="contacts"
        title="relance.popUpMail.title"
        :error="errorEmail"
        :editionsAInclure="editionsAInclure"
        @addContact="getInfoDestinataire"
        @removeContact="setInfoDestinataire"
        @sendEmail="envoieMail()">
      </pop-up-mail>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('relanceSave.popUpSuppression.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteRelance()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpArchivage" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="currentRelance.actif ?
          $t('relanceSave.archivageDesarchiver.archivage')
          : $t('relanceSave.archivageDesarchiver.desarchivage')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpArchivage = false"
        @yes="archiverRelance">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpConfEnvoie" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('relanceSave.popUpConf.titleEnvoyeRelance')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpConfEnvoie = false"
        @yes="envoyerRelance()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpConfEnregistre" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$i18n.t('relanceSave.popUpConf.titleEnregistreRelance')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpConfEnregistre = false"
        @yes="enregistrerRelance()">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import edition from '@/api/edition/index';
import PiecesJointes from '@/components/general/piecesJointes';
import breadcrumb from '@/components/general/breadcrumb';
import stepRelanceEnregistrement from '@/components/relances/stepRelanceEnregistrement';
import dropdownButton from '@/components/general/button/dropdownButton';
import {
  get,
  getByMouvementClient, archiver,
  deleteAll, updateEtat,
} from '@/api/relances/index';
import ajoutLibelleRelance from '@/services/relances/ajoutLibelleRelances';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import { RELANCE } from '@/configuration/permissionsBodacConf';
import messageSucces from '@/services/general/messageSucces';
import getInfoContacts from '@/services/general/mail/getInfoContactsMail';
import getInfosClients from '@/services/general/mail/getInfosClientMail';
import {
  TYPE_EDITION_RELANCE,
  ENVOYE, ENREGISTRE,
  GET_LAST_PAY_LOAD,
} from '@/configuration/relances/relancesConf';
import genererMail from '@/services/general/genererMail';
import envoieMailRelance from '@/services/relances/envoieMailRelance';
import validationEnvoieMail from '@/services/general/validation/validationEnvoieMail';
import popUpMail from '@/components/general/p_mail';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import {
  PIECE_JOINTE_TYPE_LOGO_RELANCE_1,
  PIECE_JOINTE_TYPE_LOGO_RELANCE_2,
  PIECE_JOINTE_TYPE_LOGO_RELANCE_3,
} from '@/configuration/general/pieceJointeConf';
import { getAll } from '@/api/facture';
import { SENS_VENTE } from '@/configuration/devisConf';
import {
  convertTierToMail,
  convertUserToMail,
  convertEmailToMail,
} from '@/services/dcf/generationMail';
import PopUpPrevention from '@/components/general/popUpPrevention';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const Relance = createNamespacedHelpers('relance');

export default {
  data() {
    return {
      allRelance: [],
      currentRelance: null,
      permissionsRelances: RELANCE,
      popUpMail: false,
      mail: null,
      editionsAInclure: [
        { libelle: 'relance.popUpMail.inclureFacture', key: 'mettreEdition', value: true },
        { libelle: 'relance.popUpMail.inclureCommande', key: 'mettreEditionCommande', value: true },
      ],
      errorEmail: {
        haveError: false,
        messages: [],
      },
      logo: '',
      contacts: [],
      payeur: null,
      allIntervenants: [],
      popUpSuppression: false,
      popUpArchivage: false,
      popUpConfEnvoie: false,
      popUpConfEnregistre: false,
      constantes: {
        ENVOYE,
        ENREGISTRE,
        GET_LAST_PAY_LOAD,
      },
      destinataire: null,
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    appBreadcrumb: breadcrumb,
    stepRelanceEnregistrement,
    dropdownButton,
    popUpMail,
    PopUpPrevention,
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    editRelance(idRelance) {
      this.$router.push({ name: 'm.bodac.relance-edition', params: { id: idRelance } });
    },
    async edition(format) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.currentRelance.id],
          extension: format,
          typeDonnee: TYPE_EDITION_RELANCE,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async checkLogoRelanceByRegleFacturation() {
      if (this.currentRelance.regleFacturationId
          && [1, 2, 3].includes(this.currentRelance.numRelance)) {
        const type = [
          PIECE_JOINTE_TYPE_LOGO_RELANCE_1,
          PIECE_JOINTE_TYPE_LOGO_RELANCE_2,
          PIECE_JOINTE_TYPE_LOGO_RELANCE_3,
        ][this.currentRelance.numRelance - 1];
        if (!type) return;
        const logoFacture = (await pGetAllPieceJointe({
          elementsId: [this.currentRelance.regleFacturationId],
        })).data.result.items.find(p => p.type.libelle === type);
        this.logo = logoFacture ? (logoFacture.cheminMin || logoFacture.chemin) : null;
      }
    },
    async changeCurrentRelance(idNewRelance) {
      try {
        this.currentRelance = this.allRelance.find((el) => {
          return el.id === idNewRelance;
        });
        this.currentRelance.payeur.id = this.currentRelance.payeurId;
        await this.checkLogoRelanceByRegleFacturation();
        await this.setAttachmentElementId({ id: this.currentRelance.id });
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    },
    classTextDroit(name) {
      return {
        'text-access-no-permission': !this.checkPermissions(this.permissionsRelances[name]),
      };
    },
    checkPermAndCallFct(permission, fct, ...Argument) {
      if (this.checkPermissions(this.permissionsRelances[permission])) {
        this[fct](Argument[0]);
      } else {
        this.showPopUp();
      }
    },
    callFct(fct, ...Argument) {
      this[fct](Argument[0]);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getNumberRelance(numberRelance) {
      if (!numberRelance) return '';
      if (numberRelance === 1) return this.$t('addNewRelance.numberRelance.first');
      return numberRelance + this.$t('addNewRelance.numberRelance.other');
    },
    async openPopUpEmail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        if (!this.allIntervenants.length) {
          const facturesIds = [...new Set(this.currentRelance.mouvementsClients.map(mvt => {
            return mvt.facture.id;
          }))];
          this.allIntervenants = await this.getAllIntervenants(facturesIds);
        }
        this.contacts = await getInfoContacts(this.allIntervenants, this.$t('relance.popUpMail.contactTitle'));
        this.contacts = this.contacts.concat(getInfosClients(this.allIntervenants, this.$t('relance.popUpMail.clientTitle')));
        this.mail = genererMail();
        if (this.currentRelance.payeur.email) {
          this.mail.to.push(convertTierToMail(this.currentRelance.payeur));
        }
        if (this.user.email) {
          this.mail.from = this.user.email;
          if (!this.userAffixe1) this.mail.cci.push(convertUserToMail(this.user));
        }
        const { emailSignataireRelance } = this.societeActive;
        if (emailSignataireRelance) {
          this.mail.cci = [convertEmailToMail(emailSignataireRelance)];
          this.mail.from = emailSignataireRelance;
        }
        this.mail.corps = this.currentRelance.texte;
        this.mail.objet = this.$t('relance.popUpMail.libelleObjet', {
          codeFacture: [...new Set(this.currentRelance.mouvementsClients.map(mvt => {
            return mvt.facture.code;
          }))].join(','),
          titreRelance: this.getNumberRelance(this.currentRelance.numRelance),
        });
        this.destinataire = null;
        this.popUpMail = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async envoieMail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        await envoieMailRelance(
          this.mail,
          this.editionsAInclure[0].value,
          this.currentRelance.mouvementsClients[0].facture.societeId,
          this.currentRelance.id,
          this.editionsAInclure[1].value,
        );
        if (!this.currentRelance.emailDestinataire
          && !this.currentRelance.nomDestinataire
          && !this.currentRelance.prenomDestinataire
          && this.destinataire) {
          await updateEtat({
            relancesIds: [this.currentRelance.id],
            etat: ENVOYE,
            nomDestinataire: this.destinataire.nom,
            prenomDestinataire: this.destinataire.prenom,
            emailDestinataire: this.destinataire.email,
          });
        }
        messageSucces(this.$i18n.t('mail.success.envoie'));
        this.popUpMail = false;
        await this.getRelances();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationEnvoieMail(e.response, this.errorEmail.messages);
          this.errorEmail.haveError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async getAllIntervenants(ids) {
      const factures = (await getAll({
        query: {
          ids: ids,
          societeId: this.societeActiveId,
          sens: SENS_VENTE,
        },
      })).data.result.items;
      const intervenants = [...new Set(factures.map(f => f.intervenants).flat())];
      return intervenants;
    },
    openPopUpEnregistre() {
      this.popUpConfEnregistre = true;
    },
    async enregistrerRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateEtat({ relancesIds: [this.currentRelance.id], etat: ENREGISTRE });
        this.popUpConfEnregistre = false;
        messageSucces(this.$t('relanceSave.messages.success.enregistrer'));
        loadingComponent.close();
        this.currentRelance.etat = ENREGISTRE;
      } catch (e) {
        this.popUpConfEnregistre = false;
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    openPopUpDelete() {
      this.popUpSuppression = true;
    },
    async deleteRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAll({
          ids: [this.currentRelance.id],
        });
        const index = this.allRelance.indexOf(this.allRelance.find((el) => {
          return el.id === this.currentRelance.id;
        }));
        this.allRelance.splice(index, 1);
        messageSucces(this.$t('relanceSave.popUpSuppression.success.oneRelance'));
        this.popUpSuppression = false;
        loadingComponent.close();
        if (!this.allRelance.length) {
          this.$router.push({ name: 'l.bodac.relance-listeRelancesSave' });
        } else {
          await this.changeCurrentRelance(this.allRelance[0].id);
        }
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    openPopUpArchivage() {
      this.popUpArchivage = true;
    },
    async archiverRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpArchivage = false;
        await archiver([this.currentRelance.id], !this.currentRelance.actif);
        messageSucces(this.currentRelance.actif ? this.$t('relanceSave.messages.success.archivage')
          : this.$t('relanceSave.messages.success.desarchivage'));
        loadingComponent.close();
        this.currentRelance.actif = !this.currentRelance.actif;
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    openPopUpEnvoi() {
      this.popUpConfEnvoie = true;
    },
    async envoyerRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpConfEnvoie = false;
        await updateEtat({ relancesIds: [this.currentRelance.id], etat: ENVOYE });
        messageSucces(this.$i18n.t('relanceSave.messages.success.envoi'));
        loadingComponent.close();
        this.currentRelance.etat = ENVOYE;
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getInfoDestinataire(contact) {
      if (!this.destinataire) {
        if (typeof contact === 'object' && contact !== null) {
          this.destinataire = contact;
        } else {
          this.destinataire = {
            email: contact,
            nom: '',
            prenom: '',
          };
        }
      }
    },
    setInfoDestinataire(contacts) {
      if (!contacts?.length) {
        this.destinataire = null;
        return;
      }
      const contact = contacts[0];
      if (typeof contact === 'object') {
        this.destinataire = contact;
      } else {
        this.destinataire = {
          email: contact || '',
          nom: '',
          prenom: '',
        };
      }
    },
    async getRelances() {
      const relance = (await get(this.$route.params.relanceId)).data.result;
      this.allRelance = (await getByMouvementClient({
        ids: relance.mouvementsClientIds,
      })).data.result;
      this.allRelance = ajoutLibelleRelance(this.allRelance);
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
      userAffixe1: 'userAffixe1',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    ...Relance.mapGetters({
      retourDetail: 'retourDetail',
    }),
    routeRetour() {
      return this.retourDetail
      ?? {
        name: 'l.bodac.relance-listeDesRetards',
        params: { getLastPayLoad: this.constantes.GET_LAST_PAY_LOAD },
      };
    },
    breadcrumb() {
      const output = [
        { title: this.$t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('relance.titleRelances'), route: { name: 'l.bodac.relance-listeRelancesSave' }, isActive: false },
        { title: this.$t('relance.DetailRelance'), route: { name: '' }, isActive: true },
      ];
      return output;
    },
    getFacturesCodes() {
      return [...new Set(this.currentRelance.mouvementsClients.map(mvt => {
        return mvt.facture.code;
      }))].join(', ');
    },
    actionSecondary() {
      const actions = [
        {
          label: this.currentRelance ? this.$t('relanceSave.actions.archiver')
            : this.$t('relanceSave.actions.desarchiver'),
          action: () => { this.callFct('openPopUpArchivage'); },
          permissionAction: RELANCE.maj,
        },
        {
          label: this.$t('relance.supprimer'),
          action: () => { this.callFct('openPopUpDelete'); },
          permissionAction: RELANCE.supprimer,
        },
      ];

      if (this.currentRelance.etat !== this.constantes.ENVOYE) {
        actions.push(
          {
            label: this.$t('relance.envoyer'),
            action: () => { this.callFct('openPopUpEnvoi'); },
            permissionAction: RELANCE.maj,
          },
        );
      }
      if (this.currentRelance.etat !== this.constantes.ENREGISTRE) {
        actions.push(
          {
            label: this.$t('relanceSave.actions.enregistrer'),
            action: () => { this.callFct('openPopUpEnregistre'); },
            permissionAction: RELANCE.maj,
          },
        );
      }

      return actions;
    },
  },
  async beforeMount() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Relance' });
      await this.getRelances();
      await this.changeCurrentRelance(this.$route.params.relanceId);
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.getFacturesCodes }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
